"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
var react_1 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var portalLoc = document.body;
var Portal = function (props) {
    var portalContainer = react_1.useState(function () { return document.createElement("div"); })[0];
    react_1.useEffect(function () {
        // Remove the portal element when it's no longer needed
        portalLoc.appendChild(portalContainer);
        return function () {
            portalLoc.removeChild(portalContainer);
        };
    }, []);
    return react_dom_1.default.createPortal(props.children, portalContainer);
};
exports.Portal = Portal;
//# sourceMappingURL=Portal.js.map